<template>
    <el-card class="main-card">
        <div slot="header" style="display: flex; align-items: center; justify-content: space-between">
            <span style="font-size: 18px; font-weight: bold">产品运维费配置</span>
            <div style="display: flex; align-items: center; gap: 8px">
                <el-select size="mini" v-model="searchModelId" placeholder="按产品型号筛选" filterable clearable
                    style="width: 220px" @change="handleSearch" @clear="handleSearch">
                    <el-option v-for="item in modelOptions" :key="item.id" :value="item.id" :label="item.name" />
                </el-select>
                <el-button size="mini" type="primary" icon="el-icon-plus" @click="openAddDialog">新增运维费</el-button>
            </div>
        </div>

        <el-table :data="tableData" border stripe v-loading="loading" style="width: 100%">
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column label="关联产品型号" min-width="150">
                <template slot-scope="scope">
                    <div v-if="modelOf(scope.row)">
                        <div>{{ modelOf(scope.row).name }}</div>
                        <div style="color: #9ca3af; font-size: 12px">{{ modelOf(scope.row).code }}</div>
                    </div>
                    <span v-else>{{ scope.row.modelId || '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="运维费用(元)" align="right" min-width="120">
                <template slot-scope="scope">
                    {{ formatPrice(scope.row.feePrice) }}
                </template>
            </el-table-column>
            <el-table-column label="状态" width="90" align="center">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
                        {{ scope.row.status === 1 ? '已激活' : '停用' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="createdTime" label="创建时间" width="160" align="center">
                <template slot-scope="scope">
                    {{ scope.row.createdTime || '--' }}
                </template>
            </el-table-column>
            <el-table-column label="更新时间" width="160" align="center">
                <template slot-scope="scope">
                    {{ scope.row.updatedTime || '--' }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="130" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="openEditDialog(scope.row)">编辑</el-button>
                    <el-button size="mini" type="text" style="color: #f56c6c"
                        @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" background class="pagination" />
        </div>

        <!-- 新增/编辑运维费弹窗 -->
        <el-dialog :title="editId ? '编辑运维费' : '新增运维费'" :visible.sync="addVisible" width="520px"
            :close-on-click-modal="false" @closed="resetAddForm">
            <el-form ref="addFormRef" :model="addForm" :rules="addRules" label-width="110px">
                <el-form-item label="关联产品型号" prop="modelId">
                    <el-select v-model="addForm.modelId" placeholder="请选择产品型号" filterable style="width: 100%">
                        <el-option v-for="item in modelOptions" :key="item.id" :value="item.id" :label="item.name">
                            <div style="display: flex; align-items: center; justify-content: space-between">
                                <span>{{ item.name }}</span>
                                <span style="color: #9ca3af; font-size: 12px">{{ item.code }}</span>
                            </div>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="运维费用(元)" prop="feePrice">
                    <el-input-number v-model="addForm.feePrice" :min="0" :max="99999999" :precision="2"
                        controls-position="right" style="width: 200px" />
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-switch v-model="addForm.status" :active-value="1" :inactive-value="0"
                        active-text="激活" inactive-text="停用" />
                </el-form-item>
            </el-form>
            <div slot="footer" style="display: flex; justify-content: flex-end; gap: 6px">
                <el-button @click="addVisible = false">取消</el-button>
                <el-button type="primary" :loading="addLoading" @click="handleSaveSubmit">保存</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
import {
    productModelOperationFeeApi,
    productModelList
} from '@/api/quote'

export default {
    name: 'ProductModelOperationFee',
    data() {
        return {
            searchModelId: '',
            loading: false,
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            modelOptions: [], // 产品型号选项（同时作为型号字典）
            modelMap: {}, // modelId -> 产品型号记录
            // 新增/编辑弹窗
            addVisible: false,
            addLoading: false,
            editId: null, // 有值表示编辑模式
            addForm: {
                modelId: null,
                feePrice: null,
                status: 1,
            },
            addRules: {
                modelId: [{ required: true, message: '请选择产品型号', trigger: 'change' }],
                feePrice: [{ required: true, message: '请输入运维费用', trigger: 'blur' }],
            },
        }
    },
    mounted() {
        this.fetchList();
        this.fetchModelOptions();
    },
    methods: {
        // 金额展示：千分位
        formatPrice(val) {
            if (val === null || val === undefined || val === '') return '--'
            return Number(val).toLocaleString()
        },

        // 取行关联的产品型号：优先接口回填的 productModel，否则查前端字典
        modelOf(row) {
            return row.productModel || this.modelMap[row.modelId] || null
        },

        // 获取运维费列表（分页）
        async fetchList() {
            this.loading = true;
            try {
                const params = {
                    current: this.currentPage,
                    size: this.pageSize,
                    filter: [],
                    sorted: [],
                }
                if (this.searchModelId) {
                    params.filter.push({
                        name: 'modelId',
                        type: 'EQ',
                        value: this.searchModelId
                    })
                }

                const res = await productModelOperationFeeApi.page(params)
                if (res && res.code === '0000') {
                    this.tableData = res.result.records || [];
                    this.total = res.result.total || 0;
                }
            } catch (error) {
                console.error('获取产品运维费列表失败：', error)
                this.tableData = [];
            } finally {
                this.loading = false;
            }
        },

        // 获取产品型号下拉选项（同时建字典用于表格型号名称显示）
        async fetchModelOptions() {
            if (this.modelOptions.length) return; // 已加载过则复用
            try {
                const param = {
                    filter: [],
                    sorted: [],
                    current: 0,
                    size: 100,
                }
                const res = await productModelList(param)
                if (res && res.code === '0000') {
                    const records = res.result.records || []
                    this.modelOptions = records
                    const map = {}
                    records.forEach(item => {
                        map[item.id] = item
                    })
                    this.modelMap = map
                }
            } catch (error) {
                console.error('获取产品型号选项失败：', error)
            }
        },

        // 打开新增弹窗
        openAddDialog() {
            this.addVisible = true;
            this.fetchModelOptions();
        },

        // 打开编辑弹窗：行数据回填
        openEditDialog(row) {
            this.editId = row.id;
            this.addForm = {
                modelId: row.modelId || null,
                feePrice: row.feePrice !== undefined && row.feePrice !== null ? row.feePrice : null,
                status: row.status !== undefined && row.status !== null ? row.status : 1,
            };
            this.addVisible = true;
            this.fetchModelOptions();
        },

        // 重置弹窗表单
        resetAddForm() {
            this.editId = null;
            this.addForm = {
                modelId: null,
                feePrice: null,
                status: 1,
            };
            this.$refs.addFormRef && this.$refs.addFormRef.clearValidate();
        },

        // 提交保存（新增/编辑）
        handleSaveSubmit() {
            this.$refs.addFormRef.validate(async (valid) => {
                if (!valid) return;
                this.addLoading = true;
                try {
                    const param = {
                        modelId: this.addForm.modelId,
                        feePrice: this.addForm.feePrice,
                        status: this.addForm.status,
                    }
                    const res = this.editId
                        ? await productModelOperationFeeApi.update({ id: this.editId, ...param })
                        : await productModelOperationFeeApi.add(param)
                    if (res && res.code === '0000') {
                        this.$message.success(this.editId ? '更新成功' : '新增成功')
                        this.addVisible = false;
                        this.fetchList();
                    } else {
                        this.$message.error(res.message || (this.editId ? '更新失败' : '新增失败'))
                    }
                } catch (error) {
                    console.error('保存产品运维费失败：', error)
                } finally {
                    this.addLoading = false;
                }
            });
        },

        // 删除运维费
        handleDelete(row) {
            const model = this.modelOf(row)
            const name = (model && model.name) || `ID ${row.id}`
            this.$confirm(`此操作将永久删除【${name}】的运维费配置, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await productModelOperationFeeApi.delete(row.id)
                    if (res && res.code === '0000') {
                        this.$message.success('删除成功')
                        // 删除后如果当前页已空且不是第一页，回退一页
                        if (this.tableData.length === 1 && this.currentPage > 1) {
                            this.currentPage -= 1;
                        }
                        this.fetchList();
                    } else {
                        this.$message.error(res.message || '删除失败')
                    }
                } catch (error) {
                    console.error('删除产品运维费失败：', error)
                }
            }).catch(() => {});
        },

        // 搜索
        handleSearch() {
            this.currentPage = 1;
            this.fetchList();
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.fetchList();
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.fetchList();
        },
    }
}
</script>

<style scoped>
.main-card {
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: none;
}

.pagination-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1890ff;
}
</style>
